import Popover from 'components/shared/Popovers/Popover/Popover';

import BreadcrumbIndicator from './Indicator';

const BreadcrumbEllipsis = ({ steps, onStepClick, indicator }) => {
  const options = steps.map((s, i) => ({
    label: s.title || s.name,
    icon: s.icon || undefined,
    onClick: () => onStepClick(i)
  }));

  return (
    <div className="flex shrink-0 items-center">
      <Popover options={options} isFixed buttonClassName="!min-w-0 !size-[24px]" />
      <BreadcrumbIndicator icon={indicator} />
    </div>
  );
};

export default BreadcrumbEllipsis;
